<template>
  <v-dialog width="350px" v-model="viewMenu">
    <v-card class="px-7 pb-2">
        <v-card-title class="mx-n7 popup-header">{{title}}</v-card-title>

        <v-layout class="ma-0" row wrap v-if="knoten">
          <v-flex xs5>


<div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
    <div class="v-input__control">
        <div class="v-input__slot">
            <div class="v-text-field__slot">
                <label for="input-x" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">X-Koord.</label>
                <input v-model.lazy="knoten.x_formated" required="required" id="input-x" type="text">
                <div class="v-text-field__suffix">{{LängenEinheit.name}}</div>
            </div>
        </div>
        <div class="v-text-field__details">
            <div class="v-messages theme--light">
                <div class="v-messages__wrapper"></div>
            </div>
        </div>
    </div>
</div>


          </v-flex>
          <v-flex xs1>
             <v-divider vertical style="min-height: 70%"></v-divider>            
          </v-flex>
          <v-flex xs5>

<div class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
    <div class="v-input__control">
        <div class="v-input__slot">
            <div class="v-text-field__slot">
                <label for="input-y" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Y-Koord.</label>
                <input v-model.lazy="knoten.y_formated" required="required" id="input-y" type="text">
                <div class="v-text-field__suffix">{{LängenEinheit.name}}</div>
            </div>
        </div>
        <div class="v-text-field__details">
            <div class="v-messages theme--light">
                <div class="v-messages__wrapper"></div>
            </div>
        </div>
    </div>
</div>


          </v-flex>
          <v-flex xs9>
            <v-select label="Auflager" v-bind:items="auflager" item-text="name" dense :menu-props="{ offsetY: true }" return-object :hint="auflager_hint" persistent-hint v-model="knoten.Auflager"></v-select>
          </v-flex>
          <v-flex xs3 class="text-xs-left">
            <v-btn-toggle>
              <v-icon class="pt-3 px-1" flat color="green" @click="$store.commit('newAuflager')">add</v-icon>
              <v-icon class="pt-3 px-1" flat color="orange" v-if="knoten.Auflager" @click="$store.commit('editAuflager',knoten.Auflager)">edit</v-icon>
              <v-icon class="pt-3 px-1" flat color="red" v-if="knoten.Auflager" @click="removeAuflager()">block</v-icon>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
                <v-btn small @click="apply()" color="grey lighten-2" >Übernehmen</v-btn>
                <v-btn small @click="cancel()" color="grey lighten-2" >Abbrechen</v-btn>
                <v-btn small v-if="!$store.getters.newKnoten" @click="deleteKnoten()" color="grey lighten-2"><v-icon dark color="red">delete_forever</v-icon></v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import KnotenClass from '../../js/Knoten.js'

export default {
    data(){
        return{
            knoten: undefined,
            LängenEinheit: this.$store.state.LängenEinheiten.m,
        }
    },
    computed: {
        auflager_hint() { return this.knoten.Auflager ? this.knoten.Auflager.info : 'kein Auflager'},
        auflager() { return this.$store.state.StatikSystem.Auflagerliste },
        title() { return this.$store.getters.newKnoten || !this.cKnoten ? 'Neuer Knoten' : this.cKnoten.name +' bearbeiten'},
        viewMenu: {
            get() { return this.$store.getters.vKnotenMenu },   
            set(value) { this.$store.commit('setvKnotenMenu', value)} 
        },
        cKnoten: {
            get() { return this.$store.getters.cKnoten },
            // set(value) { this.$store.state.cKnoten.x = value.x
            //                     this.$store.state.cKnoten.y = value.y
            //                     this.$store.state.cKnoten.Auflager = value.Auflager }
            }
        },
    methods: {
        removeAuflager(){
          this.knoten.Auflager = null
        },
        apply(){
            // if(isNaN(this.knoten.x)) this.knoten.x = parseFloat(this.knoten.x.replace(',','.'))
            // if(isNaN(this.knoten.y)) this.knoten.y = parseFloat(this.knoten.y.replace(',','.'))            
            this.$store.commit('KnotenDialogApply', this.knoten)
            this.knoten = undefined
        },
        cancel(){
            this.viewMenu = false
            this.knoten = undefined
        },
        deleteKnoten(){
            this.viewMenu = false
            this.knoten = undefined
            this.$store.commit('KnotenDialogDelete')
        }
    },
    beforeUpdate(){
        if (!this.knoten && this.viewMenu) {
          this.knoten = new KnotenClass(null, this.cKnoten.x, this.cKnoten.y, this.cKnoten.Auflager)
        } 
    },
}
</script>

<style>
    input[type=text] {
        text-align: right
    }
</style>